






























import CoSkeleton from '@/components/Atoms/co-skeleton/CoSkeleton.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';

export default {
    name: 'CoDashboard',
    components: {
        CoSkeleton,
        CoText,
        CoButton,
    },
    props: {
        dashboardID: {
            type: Number,
        },
        title: {
            type: String,
            default: '',
        },
        showLoadingState: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            loading: false,
            dashboardURL: null,
            error: false,
        };
    },
    mounted() {
        this.fetchDashboardURL();
    },
    watch: {
        dashboardID(newID, oldID) {
            if (newID !== oldID) {
                this.fetchDashboardURL();
            }
        },
    },
    methods: {
        fetchDashboardURL() {
            if (!this.dashboardID) {
                return;
            }
            this.loading = true;
            this.$store
                .dispatch('getDashboardURL', this.dashboardID)
                .then((url) => {
                    if (url === null || typeof url !== 'string') {
                        throw new Error('Invalid dashboard URL received');
                    }
                    this.dashboardURL = url
                        .replace('titled=false', 'titled=true') // add title
                        .replace('bordered=true', 'bordered=false'); // remove border
                })
                .catch(() => {
                    this.error = true;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
